import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const safetyHubClientRoutes = [
  {
    id: 'safety-hub-view',
    trackingName: 'View Security Hub',
    path: 'dl/view/security-hub',
    loader: async ({ context }) => {
      context?.browserNavigate('/account/safety')
    },
  },
] as const satisfies JourneyRoute[]
